export const CUSTOM_SECTION = 'custom';
export const GLOBAL_SECTION = 'global';
export const SERVER_REQUEST = 'server_request';
export const SERVER_RESPONSE = 'server_response';
export const AUTH_CHECKING = 'auth_checking';
export const FETCH_USER = 'fetch_user';
